export default __webpack_public_path__ + "static/media/title-aircraft.cf0ed419.svg";